// extracted by mini-css-extract-plugin
export var details = "_h0-0";
export var inspectorPopover = "_h0-1";